import { render, staticRenderFns } from "./footer_nav.vue?vue&type=template&id=1476b989"
import script from "./footer_nav.vue?vue&type=script&lang=js"
export * from "./footer_nav.vue?vue&type=script&lang=js"
import style0 from "./footer_nav.vue?vue&type=style&index=0&id=1476b989&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports